module.exports = __webpack_public_path__ + "static/premios@2xl-0616498db4de971beee9384f1edcdcdc.webp";